export interface TaxConfig {
  taxMode: "hst" | "gst_pst" | "gst_only" | "none";
  hstRate: number;
  gstRate: number;
  pstRate: number;
}

export interface TaxBreakdown {
  totalTaxCents: number;
  hstCents: number;
  gstCents: number;
  pstCents: number;
}

export function calculateTaxCents(amountCents: number, config: TaxConfig): TaxBreakdown {
  switch (config.taxMode) {
    case "hst": {
      const hstCents = Math.round(amountCents * (config.hstRate / 100));
      return { totalTaxCents: hstCents, hstCents, gstCents: 0, pstCents: 0 };
    }
    case "gst_pst": {
      const gstCents = Math.round(amountCents * (config.gstRate / 100));
      const pstCents = Math.round(amountCents * (config.pstRate / 100));
      return { totalTaxCents: gstCents + pstCents, hstCents: 0, gstCents, pstCents };
    }
    case "gst_only": {
      const gstCents = Math.round(amountCents * (config.gstRate / 100));
      return { totalTaxCents: gstCents, hstCents: 0, gstCents, pstCents: 0 };
    }
    case "none":
      return { totalTaxCents: 0, hstCents: 0, gstCents: 0, pstCents: 0 };
  }
}

export function getTaxLabel(config: TaxConfig): string {
  switch (config.taxMode) {
    case "hst": return `HST (${config.hstRate}%)`;
    case "gst_pst": return `GST (${config.gstRate}%) + PST (${config.pstRate}%)`;
    case "gst_only": return `GST (${config.gstRate}%)`;
    case "none": return "No Tax";
  }
}

export function getEffectiveRate(config: TaxConfig): number {
  switch (config.taxMode) {
    case "hst": return config.hstRate;
    case "gst_pst": return config.gstRate + config.pstRate;
    case "gst_only": return config.gstRate;
    case "none": return 0;
  }
}

export const DEFAULT_TAX_CONFIG: TaxConfig = {
  taxMode: "hst",
  hstRate: 13,
  gstRate: 5,
  pstRate: 0,
};
